import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { UN_AUTH_PATH } from "shared/constants/routes";
import { fetchCurrentStaff, fetchProfile } from "states/account/account.slice";
import { fetchBranchList } from "states/branch/branch.slice";
import {
  fetchSystemConfig,
  setLoadingApp,
} from "states/global-value/global-value.slice";
import {
  fetchLocalization,
  fetchClientLanguages,
} from "states/localization/localization.slice";
import history from "shared/plugins/history";
import { RootState } from "app.store";
import { testPrinterConnection } from "./use-printer";

export function useFetchAppData() {
  const [testedPrinter, setTestedPrinter] = useState(false);
  const dispatch = useDispatch();
  const isLogin = useSelector(
    (state: RootState) => state.account.isAuthentication,
    shallowEqual
  );
  const isUnAuthPath = () => {
    return (
      UN_AUTH_PATH.filter((m) => history.location.pathname.startsWith(m))
        .length > 0
    );
  };
  const currentBranch = useSelector(
    (state: RootState) => state.branch.currentBranch,
    shallowEqual
  );
  const fetchAdminPageData = () => {
    dispatch(fetchClientLanguages());
    dispatch(fetchProfile());
    dispatch(fetchCurrentStaff());
    dispatch(fetchBranchList());
    dispatch(fetchSystemConfig());
  };

  useEffect(() => {
    Promise.all([dispatch(fetchLocalization())])
      .then(() => {
        dispatch(setLoadingApp(false));
      })
      .catch(() => {
        dispatch(setLoadingApp(false));
      });

    if (!isUnAuthPath()) {
      fetchAdminPageData();
    }
  }, []);

  useEffect(() => {
    if (isLogin) {
      fetchAdminPageData();
    }
  }, [isLogin]);

  useEffect(() => {
    if (
      currentBranch &&
      currentBranch.defaultPrinterIp &&
      currentBranch.defaultPrinterIp.length > 0 &&
      !testedPrinter
    ) {
      setTestedPrinter(true);
      testPrinterConnection(currentBranch.defaultPrinterIp);
    }
  }, [currentBranch]);
}
